/* import __COLOCATED_TEMPLATE__ from './contact.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './contact.module.scss';

@classic
@classNames(styles.component)
export default class PracticeWebsiteContact extends Component {}
